import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../components/ui/accordion';
import { mockData } from '../mock';

const FAQ = () => {
  return (
    <section className="py-16 md:py-24 bg-white relative overflow-hidden">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="text-center mb-12 md:mb-16">
          <span className="text-blue-600 font-bold text-xs md:text-sm uppercase tracking-wider">Spørsmål og svar</span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-slate-900 mt-4 mb-4 px-4">
            Ofte stilte spørsmål
          </h2>
          <p className="text-base md:text-lg text-slate-600 px-4">
            Finn svar på de vanligste spørsmålene
          </p>
        </div>
        <Accordion type="single" collapsible className="space-y-3">
          {mockData.faqs.map((faq) => (
            <AccordionItem 
              key={faq.id} 
              value={`item-${faq.id}`}
              className="border-2 border-slate-200 rounded-xl px-5 md:px-6 hover:border-blue-300 hover:shadow-md transition-all bg-white"
            >
              <AccordionTrigger className="text-left text-base md:text-lg font-semibold hover:text-blue-600 py-4">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-slate-600 text-sm md:text-base leading-relaxed pt-1 pb-4">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;
